import React from 'react';
import { Building, User, Wrench } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative bg-white overflow-hidden py-16 sm:py-24 lg:py-32" data-id="element-243">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <div className="max-w-3xl mx-auto text-center" data-id="element-245">
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl md:text-6xl" data-id="element-246">
            <span className="block" data-id="element-247">Quality Home Services</span>
            <span className="block text-primary mt-2" data-id="element-248">At Your Fingertips</span>
          </h1>
          <p className="mt-6 text-xl text-gray-500 max-w-2xl mx-auto" data-id="element-249">
            Connect with certified professionals for painting, waterproofing,
            and micro-repair services with warranty coverage.
          </p>
          <div className="mt-10 flex justify-center gap-4 flex-wrap" data-id="element-250">
            <Link to="/request-service" className="px-8 py-3 rounded-md bg-primary text-white text-lg font-medium hover:bg-primary/90 transition-colors" data-id="element-251">
              Request Service
            </Link>
            <Link to="/auth/customer-register" className="px-8 py-3 rounded-md border border-primary text-primary text-lg font-medium hover:bg-primary hover:text-white transition-colors" data-id="element-252">
              Create Account
            </Link>
          </div>
        </div>
        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-253">
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-254">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10" data-id="element-255">
              <Wrench className="h-6 w-6 text-primary" data-id="element-256" />
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900" data-id="element-257">
              Certified Professionals
            </h3>
            <p className="mt-2 text-gray-500" data-id="element-258">
              All service providers are trained and quality-checked
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-259">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10" data-id="element-260">
              <Building className="h-6 w-6 text-primary" data-id="element-261" />
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900" data-id="element-262">
              Warranty Coverage
            </h3>
            <p className="mt-2 text-gray-500" data-id="element-263">
              Every service comes with comprehensive warranty protection
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-264">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10" data-id="element-265">
              <User className="h-6 w-6 text-primary" data-id="element-266" />
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900" data-id="element-267">
              Flexible Payments
            </h3>
            <p className="mt-2 text-gray-500" data-id="element-268">
              Pay in full or choose 0% installment options
            </p>
          </div>
        </div>
      </div>
    </section>;
}